import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Grid, Box } from "@material-ui/core";

import EqualizerIcon from "@material-ui/icons/Equalizer";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { ReactComponent as CRFIcon1 } from "../../../../Images/CRFIcon1.svg";
import { ReactComponent as NoOfAssignments } from "../../../../Images/MIIcons/counter.svg";
import { ReactComponent as InProgress } from "../../../../Images/MIIcons/inprogress.svg";
import { ReactComponent as Completed } from "../../../../Images/MIIcons/completed.svg";
import { ReactComponent as Received } from "../../../../Images/MIIcons/received.svg";
import { ReactComponent as ViewAllStatistics } from "../../../../Images/MIIcons/allstatistics.svg";
import { ReactComponent as Modules } from "../../../../Images/MIIcons/modules.svg";
import { ReactComponent as Cancelled } from "../../../../Images/MIIcons/cancelled.svg";
import { ReactComponent as Confirmed } from "../../../../Images/MIIcons/check.svg";
import { ReactComponent as ShortList } from "../../../../Images/MIIcons/shortlist.svg";
import { ReactComponent as Chemistry } from "../../../../Images/MIIcons/chemistry.svg";
import { ReactComponent as Online360 } from "../../../../Images/MIIcons/360.svg";
import { ReactComponent as CRFIcon2 } from "../../../../Images/CRFIcon2.svg";
import { ReactComponent as CRFIcon3 } from "../../../../Images/CRFIcon3.svg";
import { ReactComponent as CRFIcon4 } from "../../../../Images/CRFIcon4.svg";
import { ReactComponent as CRFIcon5 } from "../../../../Images/CRFIcon5.svg";
import StatusSummaryDrawer from "./StatusSummaryDrawer";
import DataService from "../../../../Service";

// import {CircularProgressbar} from "react-circular-progressbar";
// import UserService from "../../../../lib/services/api/admin/users/user_client";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "4%",
    width: "75%",
  },
  statsBoard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    width: "17%",
    borderLeft: "solid #077F83",
    // borderColor:'#56D9FE'
  },
  IconBorder: {
    width: "42px",
    height: "40px",
    padding: "5px",
    textAlign: "center",
    borderRadius: "5px",
  },
}));
const miIconsAssigner = (label) =>{
  const IconsStyle={width: "100%", fill: "#fff", height: "100%" }
  switch(label){
    case("no of assignments"):
    return <NoOfAssignments style={{...IconsStyle}}/>;
    case("In progress"):
    return <InProgress style={{...IconsStyle}}/>;
    case("Confirmed"):
    return <Confirmed style={{...IconsStyle}} />
    case("Received"):
    return <Received style={{...IconsStyle}}/>;
    case("Chemistry" || label.includes("session")):
    return <Chemistry style={{...IconsStyle}}/>;
    case("Completed"):
    return <Completed style={{...IconsStyle}}/>;
    case("Shortlist"):
    return <ShortList style={{...IconsStyle}}/>;
    case("View all statistics"):
    return <ViewAllStatistics style={{...IconsStyle}}/>;
    case("Cancelled"):
    return <Cancelled style={{...IconsStyle}}/>;
    case("Online 360"):
    return <Online360 style={{...IconsStyle}}/>;
    default:
    return <Modules style={{...IconsStyle}}/>;
  }
}
function UserActiveStatus(props) {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [drawer, setDrawer] = useState(false);
  const themeColor = sessionStorage.getItem("role") == "admin" ? "#077F83" : "";
  const themeColorWithOpacity =
    sessionStorage.getItem("role") == "admin" ? "#077F83" : "#981B1E";
  const [statistics, setStatistics] = useState({});
  const [viewMoreValue, setViewMoreValue] = useState(false);
const userRole=sessionStorage.getItem("role");
  useEffect(() => {
    let type="admin";
    if(userRole==="employee"){
      type="organisation";
    }
    DataService.getDirectData("/assignments/statistics", {
      type:type,
      organisation_id: props.organisationId,
    })
      .then((res) => {
        console.log(res);
        statistics.length = 0;
        setStatistics({ ...statistics, ...res });
      })
      .catch(() => {});
  }, [props.action]);

  useEffect(() => {
    if (statistics?.statistics?.length) {
      const statisticsValue = statistics?.statistics
        .slice(0, 6)
        .find((item) => item.label === props?.filterStatisticsValue);
      if (props?.filterStatisticsValue && !statisticsValue)
        setViewMoreValue(true);
      else setViewMoreValue(false);
    }
  }, [props?.filterStatisticsValue]);
  return (
    <div>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 20 }}
        spacing={2}
      >
        {/* <Grid item xs={3}>
          <Box
            boxShadow={2}
            borderRadius={5}
            p={3}
            style={{
              borderColor: "",
              borderLeft: "solid #077F83",
              backgroundColor: "#fff",
              borderWidth: viewMoreValue ? 3 : 0,
            }}
          >
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item xs={8}>
                <Typography variant="h2" style={{ color: "#320032" }}>
                  Total number of assignments
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bold", color: "#320032" }}
                >
                  {props.totalCount === -1 ? "-" :props.totalCount}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Box
                  className={classes.IconBorder}
                  style={{
                    backgroundColor: "#320032",
                    margin: "auto 0 auto auto",
                  }}
                >
                  {miIconsAssigner("no of assignments")}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid> */}
        {statistics?.statistics?.length > 0 &&
          statistics?.statistics.map((option, i) => {
            const boxStyle = {
              cursor: "pointer",
              border: 0,
              borderColor: "#077F83",
              borderStyle: "solid",
              backgroundColor: "#fff",
              width: "100%",
              textAlign: "left",
            };
            if ((props?.filterStatisticsValue === option.label))
              boxStyle["borderLeftWidth"] = 3;
            if (i < 6) {
              return (
                <Grid item xs={3}>
                  <Box
                    key={+new Date()}
                    component="button"
                    boxShadow={2}
                    borderLeft={3}
                    p={0}
                    borderRadius={5}
                    onClick={() => {
                      props.fetchAssignmentsByStatistics(option.label);
                      props?.setFilterStatisticsValue(option.label);
                    }}
                    style={boxStyle}
                  >
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ padding: 24 }}
                      spacing={2}
                    >
                      <Grid item xs={8}>
                        <Typography variant="h2" style={{ color: "#320032" }}>
                          {option.label}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bold", color: "#320032" }}
                        >
                          {option.value}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          className={classes.IconBorder}
                          style={{
                            backgroundColor: "#320032",
                            margin: "auto 0 auto auto",
                          }}
                        >
                          {miIconsAssigner(option.label)}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              );
            }
          })}
        <Grid item xs={3}>
          <Box
            boxShadow={2}
            borderRadius={5}
            p={3}
            style={{
              borderColor: "",
              borderLeft: "solid #077F83",
              backgroundColor: "#fff",
              borderWidth: viewMoreValue ? 3 : 0,
            }}
          >
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item xs={8}>
                <Box
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setDrawer(true);
                  }}
                >
                  {/* <Typography variant="h2" style={{ color: "#077F83" }}>+{statistics.additional_count}more</Typography> */}
                  <Typography
                    variant="h2"
                    style={{ color: "#077F83", fontWeight: "bold" }}
                  >
                    View all statistics
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box
                  className={classes.IconBorder}
                  style={{
                    backgroundColor: "#320032",
                    margin: "auto 0 auto auto",
                  }}
                >
                 {miIconsAssigner("View all statistics")}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {drawer && (
        <StatusSummaryDrawer
          parentCall={setDrawer}
          statistics={statistics?.statistics}
          {...props}
        />
      )}
    </div>
  );
}

export default UserActiveStatus;
